export const SUBMIT_TITLE_ERROR_MESSAGE =
  '필드 profile_id, title 는 반드시 고유(unique)해야 합니다.';
